module.exports = __webpack_public_path__ + "img/taskxq.2b23c727.svg";